import { isPro } from "./SubUtils";

export const ASSISTANT_PILOT_EMAILS = new Set([
  "chris@novum.global",
  "praveen@novum.global",
  "viet@novum.global",
]);

export const isAssistantPilotUser = (user) =>
  ASSISTANT_PILOT_EMAILS.has(String(user?.email || "").trim().toLowerCase());

export const isAssistantPublicRolloutEnabled = () =>
  String(process.env.REACT_APP_ASSISTANT_PUBLIC_ROLLOUT || "").trim().toLowerCase() === "true";

export const canAccessAssistant = (
  user,
  { publicRollout = isAssistantPublicRolloutEnabled() } = {},
) => {
  if (isAssistantPilotUser(user)) return true;
  return publicRollout && isPro(user?.user_subscription);
};
